export default {
  SET_PROGRESS: '@YOLA_EDITOR/STARTER_SCREEN/SET_PROGRESS',
};
